import React from 'react';

import IMg1 from '../assets/img/aboutimg1.png';
import Img2 from '../assets/img/aboutimg2.jpg';
import Img3 from '../assets/img/aboutimg3.png';
import Img4 from '../assets/img/aboutslide.jpg';
import Img5 from '../assets/img/ordinary.png';

import Icon1 from '../assets/img/butterfly.png';
import Icon2 from '../assets/img/star.png';
import Icon3 from '../assets/img/ink-pen.png';
import Icon4 from '../assets/img/role-model.png';
 import SeoHelmet from "../components/SeoHelmet";

const Aboutus = () => {
  return (
    <>
     <SeoHelmet />
        <section class="about">
            <div className='container'>
                <div className='row'>
                    <div className='col-sm-6'>
                        <img src={Img2} />
                    </div>
                    <div className='col-sm-6'>
                        <div className='about_content'>
                            <h2>BHAVANA SINGH</h2>
                            <p>Not an Average stylist or a Fashion Consultant. I am a personality Transformation Coach who helps you shine and be the best version of yourself.</p>
                            <img src={Img5} />
                            <p>Not an Average stylist or a Fashion Consultant. I am a personality Transformation Coach who helps you shine and be the best version of yourself.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="clients">
            <div class="container">
                <h2>Bhavana by The Numbers</h2>
                <div className='numbox'>
                    <div className='bxcol'>
                        <img src={Icon1} />
                        <p>Transformed 1000+ Lives</p>
                    </div>
                    <div className='bxcol'>
                        <img src={Icon2} />
                        <p>10+ Years of experience</p>
                    </div>
                    <div className='bxcol'>
                        <img src={Icon3} />
                        <p>Author (Chappals to Heels)</p>
                    </div>
                    <div className='bxcol'>
                        <img src={Icon4} />
                        <p>Entrepreneur with Label Bhavana Singh</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="bio">
            <div className='container'>
                <div className='bordline'></div>
                <div className='row'>
                    <div className='col-sm-6 '>
                        <div className='bio_content'>
                            <h2>Official Bio</h2>
                            <p>I help professionals & individuals build confidence & impactful personalities.<br></br>
                                Transforming lives through personalized styling & coaching.<br></br>
                                <b>Featured on NDTV & Zee5 | Trusted by 1000+ clients</b></p>
                        
                        <img src={IMg1} />
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='bio_content second_conttt'>
                            <img src={Img3} className='rightimg' />
                                <h2>My Mission is to be a mentor I needed Growing up</h2>
                                <p>Growing up, I always longed for a mentor—someone to guide me, help me shine, and enhance my personality. But I never had that support.<br></br> That experience shaped me, and today, it’s my mission to be the guide I once needed. To help YOU become the best version of yourself.<br></br> Whether it’s building confidence, enhancing your style, or transforming your mindset, I’m here to walk this journey with you. Because everyone deserves the chance to shine their brightest!<br></br> Let’s grow together, step into your power, and create the life you’ve always dreamed of.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='clientvis'>
            <div className='container'>
                <div class="clientvis_content">
                    <div class="colcontant">
                        <p>My vision is that you live a life without<br></br> limits. You dress well, you live well, make<br></br> bank, and show everyone who ever<br></br> doubted or overlooked you what's up.</p>
                    </div>
                    <div class="colimg">
                        <img src={Img4} />
                    </div>
                    <div class="colcontant seco">
                        <p>You're an absolute<br></br> boss, and no one<br></br> can stop you!</p>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}; 

export default Aboutus;
